import React from 'react';
import { useTranslation } from 'react-i18next';

import { ThemeType } from '../../../@types';
import Spinner from '../spinner/Spinner';
import styles from './loading.module.scss';

type LoadingProps = {
  isLoading?: boolean;
};

const Loading: React.FC<LoadingProps> = ({ isLoading }) => {
  const { t } = useTranslation('common');

  return isLoading ? (
    <div className={styles.loading} data-testid="loading">
      <Spinner iconSize={80} theme={ThemeType.PRIMARY} />
      <p className={styles.label}>{t('labels.loading')}</p>
    </div>
  ) : (
    <></>
  );
};

export default Loading;
